import React from 'react';
import axios from 'axios';
import styles from './chatbot.module.css';

async function get_id(){
    try{
        const response = await axios.get('https://api64.ipify.org?format=json');
        return response.data.ip;
    }
    catch(error){
        console.error(error);
    }
}
async function fetch_post(URL, data){

    let axiosConfig={

        headers:{
            'Content-Type':'application/json; charset=UTF-8'
        }
    }

    try {

        const response= await axios.post(URL,data,axiosConfig);
        console.log("response",response.data.bot)

        return( response.data.bot)
        
    } catch (error) {

        console.error(error.message);
        
    }
}
function loadchat(){

    return(

        <div  className={styles.custom}>
            <div className={styles.balls}>

                <div className={styles.ball + styles.ball1}></div>
                <div className={styles.ball + styles.ball2}></div>
                <div className={styles.ball + styles.ball3}></div>


            </div>


        </div>


       )
}
const exported = { get_id,fetch_post,loadchat}
export default exported;

